export default __webpack_public_path__ + "static/media/eye_close_icon.09229e21.svg";